import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { styles } from "../../config/config.theme";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: styles["background-secondary"],
    color: styles["text-primary"],
    fontSize: 12,
    fontFamily: styles["font-family"],
  },
}));

export default StyledTooltip;
